import { render, staticRenderFns } from "./order-refund.vue?vue&type=template&id=187f3cb2&scoped=true"
import script from "./order-refund.vue?vue&type=script&lang=js"
export * from "./order-refund.vue?vue&type=script&lang=js"
import style0 from "./order-refund.vue?vue&type=style&index=0&id=187f3cb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f3cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187f3cb2')) {
      api.createRecord('187f3cb2', component.options)
    } else {
      api.reload('187f3cb2', component.options)
    }
    module.hot.accept("./order-refund.vue?vue&type=template&id=187f3cb2&scoped=true", function () {
      api.rerender('187f3cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/ferry/order-refund.vue"
export default component.exports